import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import vSelect from 'vue-select';
import { guid } from '@/mixins/guid';
import { dynamicSetup } from '@/mixins/dynamic-setup';
import { siteBuilder } from '@/mixins/site-builder';

export default Vue.component('data-product-store-currency', {
  template: require('./template.html'),
  name: 'data-product-store-currency',
  computed: {
    ...mapGetters([
      'currentSite',
      'activeSiteType',
    ]),
    storeData() {
      return this.currentSite.dynamic.products;
    },
  },
  mixins: [guid, dynamicSetup, siteBuilder],
  components: {
    vSelect,
  },
  data() {
    return {
      loading: false,
      currencyOptions: ['USD'],
      currErrors: [],
      currency: 'USD',
      taxrate: 0,
      initialEdits: {
        currency: null,
        taxrate: null,
      },
    };
  },
  props: [
    'item-modal',
    'content',
    'active-item',
    'item-list',
    'all-categories',
  ],
  created() {
    if (this.noDynamicData(this.activeSiteType)) {
      this.dynamicSetup(this.activeSiteType);
    }
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      this.currency = _.clone(this.storeData.currency) || 'USD';
      this.taxrate = _.clone(this.storeData.taxrate) || 0;
      this.initialEdits.currency = this.currency;
      this.initialEdits.taxrate = this.taxrate;
    },
    runValidator(option) {
      this.currErrors = [];
      if (!option) {
        this.currErrors = ['Currency required.'];
      }
    },
    selectCurrency(option) {
      this.runValidator(option);
      this.currency = option;
    },
    saveChanges() {
      if (this.currErrors.length > 0) {
        return;
      }
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.currErrors = [];
          this.loading = true;
          const notif = {
            id: this.guid(),
            type: 'success',
            time: 2000,
            message: 'Store changes saved!',
          };
          try {
            this.$store.dispatch('setGlobalValue', {
              item: this.currentSite.dynamic.products,
              key: 'taxrate',
              value: this.taxrate,
            });
            this.$store.dispatch('setGlobalValue', {
              item: this.currentSite.dynamic.products,
              key: 'currency',
              value: this.currency,
            });
            await this._SEND([{
              name: 'updateSiteAttr',
              payload: {
                siteId: this.currentSite._id,
                attr: 'dynamic',
                value: this.currentSite.dynamic,
              },
            }]);
            // we also need to regenerate the site in this instance
            await this.callBuilder({
              publish: 'site',
              site: {
                _id: this.currentSite._id,
              },
            });
            this.initialEdits.currency = this.currency;
            this.initialEdits.taxrate = this.taxrate;
          } catch (e) {
            this.$log.error(e.message || e);
            notif.type = 'error';
            notif.message = e.message || e;
            await this._reportError({
              error: e,
              fn: 'saveChanges store currency',
            });
          } finally {
            this.loading = false;
            this.$store.dispatch('addNotification', notif);
          }
        }
      });
    },
    cancelChanges() {
      this.currency = this.initialEdits.currency;
      this.taxrate = this.initialEdits.taxrate;
      this.$store.dispatch('setGlobalValue', {
        item: this.currentSite.dynamic.products,
        key: 'taxrate',
        value: this._getInputVal(this.taxrate),
      });
      this.$store.dispatch('setGlobalValue', {
        item: this.currentSite.dynamic.products,
        key: 'currency',
        value: this.currency,
      });
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/store/currency/index.js